// extracted by mini-css-extract-plugin
export default {"btn":"DiscoverBotsBtn_btn__nua7J","img":"DiscoverBotsBtn_img__ODjgf","text":"DiscoverBotsBtn_text__4XCLI"};